import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex'
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minHeight: '500px'
  },
  tabPanel: {
    width: '100%',
    minHeight: '500px',
    maxHeight: '500px',
    overflowY: 'scroll'
  }
}));
